import { render } from "./Web.vue.js?vue&type=template&id=704f1c73!=!../vue-loader/dist/index.js??ruleSet[0]!./Web.vue?vue&type=template&id=704f1c73"
import script from "./Web.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Web.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__